import React from 'react';
import SliderFilter from './SliderFilter';

const CATEGORY_ID = [5];

export default function CovidCoverageFilter({ useStagingMode = false, onStageChange = null }) {
  return (
    <SliderFilter
      matchIds={CATEGORY_ID}
      title="Valor da cobertura COVID-19"
      description="Escolha o valor da cobertura para despesas relacionadas a COVID-19"
      infoTooltip="É uma cobertura extra para despesas médicas, como internação e tratamentos, em caso de diagnóstico positivo para COVID-19 durante a viagem."
      ariaLabel="Valor de Cobertura COVID-19"
      useStagingMode={useStagingMode}
      onStageChange={onStageChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/CovidCoverageFilter.jsx